/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The status of a hotel booking request. 
 * - success: 200
 * - card declined: 400
 * - available credit insufficient: 400
 * - booking not found: 404
 * - rate no longer available: 404
 * - gondola payment method not available: 404
 * - price mismatch: 409
 * - rooms unavailable: 410
 * - service busy: 423
 * 
 * @export
 */
export const HotelBookingResponseStatus = {
    Success: 'success',
    CardDeclined: 'card declined',
    AvailableCreditInsufficient: 'available credit insufficient',
    BookingNotFound: 'booking not found',
    RateNoLongerAvailable: 'rate no longer available',
    GondolaPaymentMethodNotAvailable: 'gondola payment method not available',
    PriceMismatch: 'price mismatch',
    RoomsUnavailable: 'rooms unavailable',
    ServiceBusy: 'service busy',
    Unknown: 'unknown'
} as const;
export type HotelBookingResponseStatus = typeof HotelBookingResponseStatus[keyof typeof HotelBookingResponseStatus];


export function instanceOfHotelBookingResponseStatus(value: any): boolean {
    for (const key in HotelBookingResponseStatus) {
        if (Object.prototype.hasOwnProperty.call(HotelBookingResponseStatus, key)) {
            if ((HotelBookingResponseStatus as Record<string, HotelBookingResponseStatus>)[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function HotelBookingResponseStatusFromJSON(json: any): HotelBookingResponseStatus {
    return HotelBookingResponseStatusFromJSONTyped(json, false);
}

export function HotelBookingResponseStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelBookingResponseStatus {
    return json as HotelBookingResponseStatus;
}

export function HotelBookingResponseStatusToJSON(value?: HotelBookingResponseStatus | null): any {
    return value as any;
}
